import { render, staticRenderFns } from "./AccAddX.vue?vue&type=template&id=04db2822&scoped=true&"
import script from "./AccAddX.vue?vue&type=script&lang=js&"
export * from "./AccAddX.vue?vue&type=script&lang=js&"
import style0 from "./AccAddX.vue?vue&type=style&index=0&id=04db2822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db2822",
  null
  
)

export default component.exports